import request from '@/utils/request'
// 获取商品详情
export function getGoodsDetail(params) {
	return request({
		url: '/v1/goods/detail',
		method: 'get',
		params,
		showLoading: true,
	})
}
// 获取推广商品详情
export function getPgoodsDetail(params) {
	params.t = new Date().getTime()
	return request({
		url: '/v1/publicity/detail',
		method: 'get',
		params,
		showLoading: true,
	})
}
// 商品下单
export function putOrder(data) {
	return request({
		url: '/v1/goods/put_order',
		method: 'post',
		data,
		showLoading: true
	})
}
// 创建试卷订单
export function createOrder(data) {
	return request({
		url: '/v1/paper_order/create',
		method: 'post',
		data,
		showLoading: true
	})
}
// 获取试卷
export function getExamPaper(params) {
	return request({
		url: '/v1/paper_order/detail',
		method: 'get',
		params,
		showLoading: true
	})
}
// 答案提交
export function answerSave(data) {
	return request({
		url: '/v1/paper/tempSave',
		method: 'post',
		data,
	})
}
// 试卷提交
export function examPaperSave(data) {
	return request({
		url: '/v1/paper/save',
		method: 'post',
		data,
		showLoading: true
	})
}
// 赠送
export function sendGoods(data) {
	return request({
		url: '/v1/goods/send',
		method: 'post',
		data,
		showLoading: true
	})
}
// 根据订单号查询已做的题目
export function getDetailAnswer(params) {
	return request({
		url: '/v1/paper_order/getDetailAnswer',
		method: 'get',
		params,
		showLoading: true
	})
}
// 重测接口
export function resetPaper(data) {
	return request({
		url: '/v1/paper_order/resetPaper',
		method: 'post',
		data,
		showLoading: true
	})
}
// 查询订单信息
export function getPaperOrderStatus(params) {
	return request({
		url: '/v1/paper_order/getPaperOrderStatus',
		method: 'get',
		params,
		showLoading: true
	})
}


export const getOrderCouponInfo = (params) => {
	return request({
		url: '/v1/goods_order/getOrderRedPacket',
		method: 'get',
		params,
		hideErrorMessage: true
	})
}

